import { Candidate } from '@/lib/model';
import * as React from 'react';
import './index.scss';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const IS_BALLOTTAGGIO_ACTIVE =
  process.env.REACT_APP_IS_BALLOTTAGGIO_ACTIVE === 'true';

export const Coalition: React.FC<Candidate> = ({
  label,
  fullName,
  eletto,
  elettoAlSecondoTurno,
  votes,
  percentage,
  fillColor,
}) => (
  <div className="Coalition">
    <div className="Coalition__title">
      <div>
        {fullName && 'S' === eletto && (
          <div>
            <span
              className={`Coalition__title__label ${
                fullName ? 'Coalition__title__label__fullName' : ''
              }`}
            >
              {fullName.replace(
                'LETIZIA MARIA BRICHETTO ARNABOLDI',
                'LETIZIA MORATTI'
              )}
            </span>
            <CheckCircleIcon style={{ marginLeft: 10 }} />
            <span
              className={`Coalition__title__label ${
                fullName ? 'Coalition__title__label__fullName' : ''
              }`}
            >{elettoAlSecondoTurno ? 'Eletto al secondo turno' : 'Eletto al primo turno'}</span>
          </div>
        )}
        {fullName && 'S' !== eletto &&(
          <span
            className={`Coalition__title__label ${
              fullName ? 'Coalition__title__label__fullName' : ''
            }`}
          >
            {fullName.replace(
              'LETIZIA MARIA BRICHETTO ARNABOLDI',
              'LETIZIA MORATTI'
            )}
          </span>
        )}
        {!fullName && (
          <span
            className={`Coalition__title__label ${
              fullName ? 'Coalition__title__label__fullName' : ''
            }`}
          >
            {' '}
            {label}
          </span>
        )}
        {fullName && (
          <span className="Coalition__title__fullName">{label}</span>
        )}
      </div>
    </div>
    <div className="Coalition__data">
      <div className="Coalition__bar">
        <div style={{ backgroundColor: fillColor, width: `${percentage}%` }} />
      </div>
      <div className="Coalition__values">
        <span>{votes === 'NaN' ? `0` : votes}</span>
        <span>{`${percentage}%`}</span>
      </div>
    </div>
  </div>
);
